import { useMutation } from '@pinia/colada';

import { useAlertsStore } from '@tallo/design-system';

import { SubmitMessageFeedbackPayload } from '../models/message-feedback.interface';
import conversationService from '../services/conversation.service';

/**
 * Deliberately not wrapped in `defineMutation`: that would share a single mutation instance across every
 * message row, so rating one message would put every other message's buttons into the loading state.
 * Each `conversation-message-feedback` instance calls this and owns its own state.
 */
export function useSubmitMessageFeedbackMutation() {
  const alertsStore = useAlertsStore();

  return useMutation({
    mutation(payload: SubmitMessageFeedbackPayload) {
      return conversationService.submitMessageFeedback(payload);
    },

    onSuccess(_, payload) {
      if (payload.rating === 'up') {
        alertsStore.success('Thanks — logged as a good reply.');
      } else {
        alertsStore.success('Feedback shared. The renter never sees this.');
      }
    },

    onError(error) {
      alertsStore.catchError(error);
    },
  });
}
